// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables for Instec */\n\n/* Mixins */\n.cropper-dialog {\n  max-width: 420px;\n  border-radius: 8px;\n}", ""]);
// Exports
exports.locals = {
	"menuBg": "#0F4C81",
	"menuText": "#ffffff",
	"menuActiveText": "#0F4C81",
	"menuActiveBg": "#ffffff"
};
module.exports = exports;
